import { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import posService from "../../services/pos/pos.service";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";

interface AdjustRawMaterialsProps {
  visible: boolean;
  onHide: () => void;
  rawmaterial: any;
  onSuccess: (posId: number) => void; 
  setLoading: (loading: boolean) => void;
}

interface SourceType {
  id: number;
  name: string;
}

const AdjustRawMaterials: React.FC<AdjustRawMaterialsProps> = ({ visible, onHide, rawmaterial,onSuccess,setLoading }) => {
  const toast = useRef<Toast>(null);
  const [quantity, setQuantity] = useState<number>(0);
  const [selectedSourceType, setSelectedSourceType] = useState<SourceType | null>(null);
  const [sourceType, setSourceType] = useState<SourceType[]>([]);
  const [batchCode, setBatchCode] = useState<string>("");
  const [reason, setReason] = useState<string>("");
  const [note, setNote] = useState<string>("");

   const [vendorOptions, setVendorOptions] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<any | null>(null);
  const [invoiceOptions, setInvoiceOptions] = useState<any[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<any | null>(null);

  const loadSourceTypeDropdown = async () => {
    try {
      const sourcetyperesponse = await posService.GetAdjustSourceType();
      debugger
        if (Array.isArray(sourcetyperesponse)) {
        setSourceType(sourcetyperesponse);
      }
    }catch (error) {
      console.error("Failed to load dropdown data", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Could not load dropdown data",
      });
    }
  }

   const loadVendors = async () => {
    try {
      const data = {
        rawMaterialId: rawmaterial.rawMaterialId,
        posId: rawmaterial.posId,
      };
      const vendors = await RawMaterialService.GetVendorandInvoiceWiseQty(data);
      debugger
      setVendorOptions(Array.isArray(vendors) ? vendors : []);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Could not load vendors",
      });
    }
  };

  useEffect(() => {
      if (visible) {
        loadSourceTypeDropdown();
        loadVendors();
      }
      if (!visible) {
      setQuantity(0);
      setSelectedSourceType(null);
      setBatchCode("");
      setReason("");
      setNote("");
      setSelectedVendor(null);
      setSelectedInvoice(null);
      setVendorOptions([]);
      setInvoiceOptions([]);
    }
    }, [visible]);


    useEffect(() => {
    if (selectedVendor) {
      const vendor = vendorOptions.find(v => v.vendorId === selectedVendor);
      setInvoiceOptions(vendor?.invoices || []);
    } else {
      setInvoiceOptions([]);
    }
  }, [selectedVendor]);

  const handleSubmit = async () => {
   
    if (!quantity || quantity <= 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please enter a valid quantity.",
      });
      return;
    }

     if (!selectedSourceType) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please select a source type.",
      });
      return;
    }

    if (!selectedVendor) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please select a vendor.",
      });
      return;
    }

    if (!reason) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please enter a Reason.",
      });
      return;
    }

    if (!batchCode) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please enter a document Detials.",
      });
      return;
    }

    if (rawmaterial.measurementTypeId === 4 && !Number.isInteger(quantity)) {
        toast.current?.show({
          severity: "warn",
          summary: "Validation Error",
          detail: "Decimal quantities are not allowed for this Raw Material.",
        });
        return;
      }


    if (quantity > rawmaterial.currentStock) {
  toast.current?.show({
    severity: "warn",
    summary: "Validation Error",
    detail: `Entered quantity exceeds available stock (${rawmaterial.currentStock}).`,
  });
  return;
}

  if (selectedVendor && !selectedInvoice) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please select an invoice for the selected vendor.",
    });
    return;
  }

  if (selectedInvoice && quantity > selectedInvoice.quantity) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: `Entered quantity exceeds invoice quantity (${selectedInvoice.quantity}).`,
    });
    return;
  }

    const payload = {
    rawMaterialId: rawmaterial.rawMaterialId, 
    Posid: rawmaterial.posId,      
    Quantity: quantity,
    SourceTypeId: selectedSourceType?.id,     
    Reason:reason,
    DocumentDetails: batchCode,
    Note: note,
    VendorId: selectedVendor,
    InvoiceNumber: selectedInvoice?.invoiceNumber,
    RawMaterialPurchaseId: selectedInvoice?.rawMaterialPurchaseId,
  };
debugger
  try {
    setLoading(true);
    const response = await RawMaterialService.AddRawMaterialAdjust(payload);
    if (response && response.isSuccess) {
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: response.message || "Inward data submitted successfully",
      });
      onHide(); // Close modal on success
      onSuccess(rawmaterial.posId); 
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: response?.message || "Failed to submit Adjust data",
      });
    }
  } catch (error) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "An error occurred during submission",
    });
  }finally {
    setLoading(false); // Always stop loading
  }
};

  return (
    <>
      <Toast ref={toast} />
      <Dialog header="Adjust Raw Material" visible={visible} onHide={onHide} breakpoints={{ '960px': '90vw' }} style={{ width: '30vw' }} modal>
        <div className="p-inputtext p-component bg-gray-100 py-2 px-3 rounded">
          {rawmaterial?.rawMaterialName || '-'}
        </div>
        <div className="p-fluid">
        <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Quantity</label>
          <InputText type="number" min="0" keyfilter="pnum" onChange={(e) => setQuantity(+e.target.value)} 
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
        </div>

        <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Source Type</label>
          <Dropdown 
            value={selectedSourceType} 
            onChange={(e) => setSelectedSourceType(e.value)} 
            options={sourceType} 
            optionLabel="name" 
            placeholder="Select a SourceType"  
            style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
        </div>

          {/* Vendor Dropdown */}
          <div className="mb-3">
            <label className="font-semibold text-sm block mb-1">Vendor</label>
              <Dropdown
                  value={selectedVendor}
                  options={vendorOptions}
                  optionLabel="vendorName"
                  optionValue="vendorId"
                  style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
                  onChange={(e) => setSelectedVendor(e.value)}
                  placeholder="Select Vendor"
                  itemTemplate={(option) => (
                    <div>
                      {option.vendorName} - {option.totalQuantity}
                    </div>
                  )}
                  valueTemplate={(option) =>
                    option ? `${option.vendorName} - ${option.totalQuantity}` : "Select Vendor"
                  }
            />
          </div>

          {/* Invoice Dropdown */}
          {selectedVendor && (
            <div className="mb-3">
              <label className="font-semibold text-sm block mb-1">Invoice Number</label>
            <Dropdown
                  value={selectedInvoice?.invoiceNumber || null}
                  options={invoiceOptions}
                  style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
                  optionLabel="invoiceNumber"
                  optionValue="invoiceNumber"
                  onChange={(e) => {
                    const selected = invoiceOptions.find((inv) => inv.invoiceNumber === e.value);
                    setSelectedInvoice(selected);
                  }}
                  placeholder="Select Invoice"
                  itemTemplate={(option) => (
                    <div>
                      {option.invoiceNumber} - {option.quantity}
                    </div>
                  )}
                  valueTemplate={(option) =>
                    option ? `${option.invoiceNumber} - ${option.quantity}` : "Select Invoice"
                  }
            />
            </div>
          )}

        <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Reason</label>
          <InputText value={reason} onChange={(e) => setReason(e.target.value)} 
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
        </div>

        <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Batch Code / Document Log</label>
        <InputText value={batchCode} onChange={(e) => setBatchCode(e.target.value)} 
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
        />
        </div>

        <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Note <span className="text-danger">*</span></label>
          <InputText value={note} onChange={(e) => setNote(e.target.value)} 
           maxLength={255}
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
           <small style={{ display: 'block', marginTop: '5px', color: '#6c757d' }}>
            {note.length} / 255
          </small>
        </div>

          <Button label="Submit" className="mt-4" onClick={handleSubmit} />
        </div>
      </Dialog>
    </>
  );
};

export default AdjustRawMaterials;
